import SubdirectoryArrowRight from '@mui/icons-material/SubdirectoryArrowRight';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Link } from '@openx/components-core/lib/Link/Link';
import { useTranslation } from 'react-i18next';

import type { Group } from '../../utils/context/DealHookTypes';
import { DealGroupControl } from '../DealGroupControl/DealGroupControl';

import { LinkWithState } from './LinkWithState';

type DealGroupListItemProps = Group[number] & { isOutside: boolean; details: boolean };

export const DealGroupListItem = ({
  details,
  id,
  isOutside,
  name,
  uid,
  targetingWithUrlTargeting,
}: DealGroupListItemProps) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{ alignItems: 'center', display: 'flex', flexDirection: 'row', gap: 0.5, justifyContent: 'space-between' }}
      data-test="grouped-row-item"
    >
      <Box sx={{ alignItems: 'center', display: 'flex', flexDirection: 'row', gap: 0.5 }}>
        <SubdirectoryArrowRight sx={theme => ({ color: theme.palette.text.secondary, fontSize: '18px' })} />

        {!details ? (
          <LinkWithState name={name} uid={uid} isOutside={isOutside} />
        ) : (
          <Link to={`/deals/${uid}/details`} isDisabled={!isOutside} data-test={`grouped-item-deal-${name}-link`}>
            {name}
          </Link>
        )}

        <Typography variant="body1" data-test={`grouped-item-id-${id}`}>
          {t('(ID: {id})', { id })}
        </Typography>
      </Box>

      <DealGroupControl targeting={targetingWithUrlTargeting} />
    </Box>
  );
};
